new SplitType('.fullmenu_nav_title_txt', {
    types: 'words, chars',
    charClass: "fullmenu_nav_title_txt-span",
    wordClass: "fullmenu_nav_title_txt-word",
    tagName: "span",
});

const click = document.querySelector(".header_hamburger");
const close = document.querySelector(".fullmenu_close");
const fullmenu_area = document.querySelector(".fullmenu_area");
const hideOverflow = document.querySelector("body");
click.addEventListener('click', () => {
  console.log("open");
    fullmenu_area.classList.add("fullmenu_opened");
    fullmenu_area.classList.remove("full_menu_hide");
    fullmenu_area.classList.remove("fullmenu_closed");
    hideOverflow.classList.add("overflow-hidden");
})
close.addEventListener('click', () => {
    console.log("hello");
    fullmenu_area.classList.remove("fullmenu_opened");
    fullmenu_area.classList.add("fullmenu_closed");
   hideOverflow.classList.remove("overflow-hidden");
})

var openSubmenu = document.querySelectorAll(".submenu_btn");
var subMenu = document.querySelectorAll(".submenu_title")
openSubmenu.forEach(function (openSubmenu) {
    openSubmenu.addEventListener('click', function () {
        this.parentElement.parentElement.classList.toggle("sub_menu_active");
    })
})